
import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
// import { NotificationService } from './SharedServices/notification.service';
// import { NotificationModel, NotificationType } from '../Model/notificationModel';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  baseUrl = environment.BaseApiUrl;
  
  constructor(
    public authService: AuthService) { }
  token = this.authService.getToken();

  headerWithToken() {
    const tokenstring = 'Bearer ' + this.authService.getToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': tokenstring
      })
    };
    return httpOptions;
  }

  headerWithTokenPayment(token: string) {
    const tokenstring = 'bearer ' + token;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': tokenstring
      })
    };
    return httpOptions;
  }

  headerWithTokenFile() {
    const tokenstring = 'bearer ' + this.token;
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': tokenstring,
      }),
    };
    return httpOptions;
  }

  headerWithTokenGetFiles(token: string) {
    const tokenstring = 'bearer ' + token;
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': tokenstring,
      }),
    };
    return httpOptions;
  }

  headerWithTokenXml(token: string) {
    const tokenstring = 'bearer ' + token;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/xml;charset=utf-8',
        'Authorization': tokenstring
      })
    };
    return httpOptions;
  }

 headerWithCSRFTokenFile(csrfToken: any) {
    const tokenstring = 'bearer ' + this.token;
    const httpOptions = {
      headers: new HttpHeaders({ 
        'Authorization': tokenstring,
        'X-CSRF-TOKEN': csrfToken
      }),
    };
    return httpOptions;
  }
}
